// extracted by mini-css-extract-plugin
export default {"innerWrapper":"MF-z","tooltipWrapper":"NF-z","icon":"OF-z","tooltip":"PF-z","content":"QF-z"};